import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, OnInit, Output, OnDestroy } from '@angular/core';
import { AuthenticationResult } from '@azure/msal-browser';
import { OutLookService } from 'src/app/services/out-look.service';
import { User } from 'src/app/services/user';
import { NewEvent } from './new-event';

import { parseISO } from 'date-fns';
import { endOfWeek, startOfWeek } from 'date-fns/esm';
import { zonedTimeToUtc } from 'date-fns-tz';
import { findIana } from 'windows-iana';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { GraphService } from 'src/app/services/graph.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-outlook-calender',
  templateUrl: './outlook-calender.component.html',
  styleUrls: ['./outlook-calender.component.scss']
})
export class OutlookCalenderComponent  implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';


  @Output() setIsAuthenticated: EventEmitter<any> = new EventEmitter<any>();

    model = new NewEvent();

  // Is a user logged in?
  get authenticated(): boolean {
    return this.authService.authenticated;
  }
  // The user
  get user(): User | undefined {
    return this.authService.user;
  }

  constructor(private authService: OutLookService,  private graphService: GraphService, private snackBar: MatSnackBar, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
}

  async ngOnInit() {
    // Necessary to handle logout redirect properly
    // See https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/errors.md
    this.authService.handleRedirects().subscribe({
      next: (result: AuthenticationResult) => {},
      error: (error: any) => {
        console.log(error);
      },
    });


    this.setIsAuthenticated.emit(this.authenticated);
    
  }

  async signIn(): Promise<void> {
    await this.authService.signIn();
    this.setIsAuthenticated.emit(this.authenticated);
    
  }


    async onSubmit(): Promise<void> {
    const timeZone = this.authService.user?.timeZone ?? 'IST';
    const graphEvent = this.model.getGraphEvent(timeZone);

    try {
      await this.graphService.addEventToCalendar(graphEvent);
    
    } catch (error: any) {

      this.snackBar.open(error.message, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
    }
  }

   public events?: MicrosoftGraph.Event[];

     formatDateTimeTimeZone(
    dateTime: MicrosoftGraph.DateTimeTimeZone | undefined | null): Date | undefined {
    if (dateTime == undefined || dateTime == null) {
      return undefined;
    }

    try {
      return parseISO(dateTime.dateTime!);
    } catch (error) {
    

      this.snackBar.open(error, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      return undefined;
    }
  }


  async signOut(): Promise<void> {
    await this.authService.signOut();

    
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}



